import { HT, SITE_ORIGIN } from "../siteConfig";
import SEO from "../components/seo.jsx"
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
const cinzel = { fontFamily: "'Cinzel', serif" };

/* ============================================================
   PAGE DATA swap this object to create a new page
============================================================ */
const PAGE = {
  hero: {
    eyebrow: HT.menu,
    heading: HT.costLabel,
    sub: "Transparent pricing, world-class quality and affordable options everything you need to plan your hair restoration journey.",
    headingPlain: "Hair Transplant",
    headingAccent: `Cost in ${HT.placeName}`,
    tagline: "Transparent Pricing, Real Results.",
    glance: {
      title: "At a glance - Clinique Internationale",
      rows: [
        { label: "Sapphire FUE Cost / Graft", val: "₹30" },
        { label: "DHI Cost / Graft", val: "₹50" },
        { label: "Success Rate in India", val: "98.5%" },
        { label: "Lead Surgeon", val: "Dr. Bhavesh Gupta" },
      ],
    },
  },

  breadcrumb: [
    { label: "Home", href: "/" },
    { label: HT.menu, href: null },
    { label: HT.costLabel, href: null },
  ],

  /* ── SECTION 1 What is Hair Transplant ── */
  whatIs: {
    eyebrow: "Overview",
    heading: `What is Hair Transplant in ${HT.placeName}?`,
    paragraphs: [
      `Hair transplant in ${HT.placeName} is a cosmetic surgical procedure designed to address hair loss and baldness. The process involves harvesting hair follicles from donor areas, often the back of the scalp, and then implanting them into areas with thinning or no hair. Skilled surgeons perform this procedure using advanced techniques like Sapphire FUE or DGI / DHI / FUT. India has gained recognition as a hub for hair transplants due to its affordable costs, experienced medical professionals and modern clinics, attracting individuals seeking effective solutions to restore their hair and confidence.`,
      "Discover premier hair transplant solutions at Clinique Internationale Mumbai, India. Our esteemed surgeons employ cutting-edge hair transplant techniques to artfully restore your hair, ensuring seamless, natural outcomes. With a commitment to excellence and a convenient Mumbai location, we provide the ideal destination for transforming your hair and confidence.",
    ],
    stats: [
      { val: "₹40K+", sub: "Starting cost per procedure" },
      { val: "98.5%", sub: "Success rate in India" },
      { val: "₹30–₹50", sub: "Cost per graft" },
      { val: "4", sub: "Clinique centres across India" },
    ],
  },

  /* ── SECTION 2 Pricing cards ── */
  pricing: {
    eyebrow: "PROCEDURE-WISE PRICING",
    heading: `Best Hair Transplant Cost in ${HT.placeName}`,
    intro: [
      "What you pay for a hair transplant comes down to two things: the technique chosen and the number of grafts you need. We offer Sapphire FUE, DHI and FUT, and your graft count is planned after assessing your stage of hair loss on the Norwood scale.",
    ],
    cards: [
      {
        label: "Sapphire FUE Technique",
        title: "Follicular Unit Extraction with Sapphire Blades",
        href: null,
        desc: "Grafts are extracted one by one and placed into micro-channels made with sapphire blades for quicker healing and dense, natural packing.",
        perGraft: "₹30",
        range: "₹30,000 – ₹90,000",
        rangeNote: "for 1,000–3,000 grafts",
        features: [
          "Finer micro-channels for denser, natural packing",
          "Faster healing with less scabbing and redness",
          "Minimal trauma to surrounding hair",
          "No linear scar, short-hair friendly",
          "Suitable for scalp and facial hair",

        ],
        featured: false,
      },
      {
        label: " Directed Graft Implantation",
        title: "Directed Graft Implantation (DGI)",
        href: null,
        desc: "Each small group of grafts is directed to the forcep or implanter as per its thickness immediately after extraction without significant out of body time.",
        perGraft: "₹50",
        range: "₹50,000 – ₹1,50,000",
        rangeNote: "for 1,000–3,000 grafts",
        features: [
          "Hybrid implantation with Forcep & Keep implanter ",
          "Shorter out-of-body time for better graft survival",
          "Precise control of angle, depth and direction",
          "Ideal for hairline design and highdensity zones",
          "Less bleeding and a quicker recovery",
        ],
        featured: true,
      },
      {
        label: "FUT Technique",
        title: "Follicular Unit Transplant (FUT)",
        href: "/follicular-unit-extraction.php",
        desc: "A strip of donor skin is removed and divided into grafts. We reserve it for Norwood Grade 7 patients with a very limited donor area, where every available graft counts.",
        perGraft: "₹50",
        range: null,
        rangeNote: "estimate shared after consultation",
        features: [
          "Maximum grafts in a single session",
          "Makes the most of a very limited donor area",
          "An option for advanced Norwood Grade 7 baldness",
          "Graft count assessed at consultation",
          "Pricing shared on consultation",
        ],
        featured: false,
      },
    ],
    cta: "Book an Appointment",
  },

  /* ── SECTION 3 Factors ── */
  factors: {
    eyebrow: "Key Considerations",
    heading: `Factors Influencing Hair Transplant Cost in ${HT.placeName}`,
    intro: `Hair transplant cost is influenced by a multitude of variables that must be taken into consideration. We pride ourselves on offering transparency and clarity when it comes to our pricing structure, allowing our clients to plan effectively for their hair transplant journey. Let's explore the key factors that contribute to the cost of a hair transplant in ${HT.placeName}.`,
    list: [
      {
        num: "01",
        title: "Experience and Reputation of the Surgeon",
        desc: "A highly experienced, qualified and reputed surgeon with a proven track record will typically charge more for their services as he has developed the art of hair restoration over a period of years. It is said that a surgeon usually requires minimum 10 years of experience to develop this fine skill of hair surgeries.",
      },
      {
        num: "02",
        title: "Type of Hair Transplant Procedure Performed",
        desc: "A surgeon usually charges more for FUT technique as it is a surgical procedure done only with the surgeon's hands. FUE is in general slightly cheaper compared to FUT, but it depends from clinic to clinic and surgeon to surgeon.",
      },
      {
        num: "03",
        title: "Number of Grafts Required",
        desc: "The number of grafts needed for the transplant directly affects the cost. Grafts are units of hair follicles that are transplanted. The higher the number of grafts required, the more intricate and time-consuming the procedure, which influences the cost accordingly.",
      },
      {
        num: "04",
        title: "Expertise of the Medical Team",
        desc: "The expertise and reputation of the medical team performing the hair transplant play a significant role in cost determination. Highly experienced surgeons and skilled medical staff often command higher fees due to their proven track record of successful outcomes.",
      },
      {
        num: "05",
        title: "Location of the Clinic",
        desc: "The geographical location of the clinic is a contributing factor. Metros and urban centres may have higher costs due to increased overheads, while clinics in smaller towns might offer more competitive pricing.",
      },
      {
        num: "06",
        title: "Clinic Facilities and Amenities",
        desc: "The facilities and amenities offered by the clinic can also impact the cost. Clinics that offer more luxurious amenities like five-star hotel stays, airport transfers, etc. may charge a premium for their services.",
      },
      {
        num: "07",
        title: "Post-Transplant Care",
        desc: "Comprehensive post-transplant care and support are essential for optimal results. Clinics that offer tailored aftercare packages, including follow-up appointments and guidance, may have slightly higher costs that reflect the quality of service provided.",
      },
    ],
  },

  /* ── SECTION 4 Methods & Costs ── */
  methodsCost: {
    eyebrow: "Technique-wise Pricing",
    heading: `Hair Transplant Methods and Their Costs in ${HT.placeName}`,
    intro: `Are you considering a hair transplant in ${HT.placeName} and wondering about the various methods available along with their associated costs? At Clinique Internationale, we understand the importance of making an informed decision, and we're here to guide you through the different hair transplant methods and their respective pricing.`,
    sapphire: {
      title: "Sapphire FUE",
      href: null,
      desc: "Sapphire FUE uses sapphire blades for making recipient-site incisions and involves individual follicular extraction. The cost is calculated at ₹30 per graft.",
      heads: ["Number of Grafts", "Price per Graft", "Cost of Sapphire FUE Hair Transplant"],
      rows: [
        { grafts: "500 Grafts",   rate: "₹30 per graft", cost: "₹15,000" },
        { grafts: "1,000 Grafts", rate: "₹30 per graft", cost: "₹30,000" },
        { grafts: "1,500 Grafts", rate: "₹30 per graft", cost: "₹45,000" },
        { grafts: "2,000 Grafts", rate: "₹30 per graft", cost: "₹60,000" },
        { grafts: "2,500 Grafts", rate: "₹30 per graft", cost: "₹75,000" },
        { grafts: "3,000 Grafts", rate: "₹30 per graft", cost: "₹90,000" },
      ],
    },
    dhi: {
      title: "Direct Hair Implantation (DHI)",
      href: null,
      desc: "DHI uses an implantation device to place extracted follicles into the recipient area. The cost is calculated at ₹50 per graft.",
      heads: ["Number of Grafts", "Price per Graft", "Cost of DHI Hair Transplant"],
      rows: [
        { grafts: "500 Grafts",   rate: "₹50 per graft", cost: "₹25,000" },
        { grafts: "1,000 Grafts", rate: "₹50 per graft", cost: "₹50,000" },
        { grafts: "1,500 Grafts", rate: "₹50 per graft", cost: "₹75,000" },
        { grafts: "2,000 Grafts", rate: "₹50 per graft", cost: "₹1,00,000" },
        { grafts: "2,500 Grafts", rate: "₹50 per graft", cost: "₹1,25,000" },
        { grafts: "3,000 Grafts", rate: "₹50 per graft", cost: "₹1,50,000" },
      ],
    },
  },

  /* ── SECTION 5 Why Clinique is Cost Effective ── */
  whyClinique: {
    eyebrow: "Why Choose Us",
    heading: "Why Clinique Internationale is Cost-Effective for Hair Transplant",
    intro: `When it comes to undergoing a hair transplant procedure in ${HT.placeName}, cost-effectiveness is a key consideration for many individuals. At Clinique Internationale, we take pride in offering exceptional hair transplant services that are not only of high quality but also cost-effective.`,
    points: [
      {
        num: "01",
        title: "Expertise and Reputation",
        desc: "Clinique Internationale boasts a team of highly experienced and skilled medical professionals who specialise in hair transplant procedures. Our surgeons have a proven track record of delivering successful outcomes, ensuring that you receive the best possible care without compromising on quality.",
      },
      {
        num: "02",
        title: "Advanced Technique",
        desc: "We utilise cutting-edge hair transplant techniques, including Follicular Unit Extraction (FUE) and Follicular Unit Transplantation (FUT). Our advanced techniques not only ensure superior results but also minimise the invasiveness of the procedure.",
      },
      {
        num: "03",
        title: "Personalised Treatment Plans",
        desc: "At Clinique Internationale, we understand that every individual's hair loss situation is unique. Our approach involves creating personalised treatment plans tailored to your specific needs, so you pay only for what is truly required.",
      },
      {
        num: "04",
        title: "Transparent Pricing",
        desc: "We believe in transparency and clarity when it comes to our pricing structure. Our patients are provided with comprehensive information about all costs associated with the hair transplant procedure with no hidden fees.",
      },
      {
        num: "05",
        title: "Proven Results",
        desc: "Clinique Internationale's reputation is built on the foundation of proven results and patient satisfaction. We believe that delivering outstanding outcomes is the most cost-effective approach in the long run, as satisfied patients often become our strongest advocates.",
      },
    ],
  },

  /* ── CTA ── */
  cta: {
    eyebrow: "Get Started",
    heading: "Plan Your Hair Transplant Today",
    sub: "Book a personalised consultation with our specialists at any of our 5 centres across India. Get an accurate graft count, cost estimate and treatment plan all in one visit.",
    primary:   { label: "Book Consultation", href: "/khargharNaviMumbai.php" },
    secondary: { label: "View All Treatments", href: "/about-hair-transplants.php" },
  },
};

/* ============================================================
   REUSABLE SUB-COMPONENTS
============================================================ */
function Eyebrow({ children, light = false }) {
  return (
    <p style={cinzel} className={`text-[10.5px] tracking-[0.28em] uppercase mb-3 flex items-center justify-center gap-2.5 ${light ? "text-[#c9a84c]/70" : "text-[#a07828]"}`}>
      <span className={`w-6 h-px ${light ? "bg-[#c9a84c]/50" : "bg-[#c9a84c]"}`} />
      {children}
    </p>
  );
}

function SectionHeading({ children, light = false, left = false }) {
  return (
    <h2 style={cinzel} className={`font-black text-[1.3rem] sm:text-[1.6rem] md:text-[1.85rem] uppercase tracking-[0.05em] mb-8 ${light ? "text-white" : "text-[#1a0f02]"} ${left ? "text-left" : "text-center"}`}>
      {children}
    </h2>
  );
}

function GoldDivider() {
  return <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/30 to-transparent" />;
}

function StyledTable({ heads, children }) {
  return (
    <div className="overflow-x-auto rounded-2xl border border-[#c9a84c]/20 shadow-[0_4px_24px_rgba(90,60,10,0.07)]">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-[#0e0905]">
            {heads.map((h) => (
              <th key={h} style={cinzel} className="text-left text-[11px] tracking-[0.1em] uppercase text-[#c9a84c] px-5 py-4 font-bold whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

function CheckIcon({ featured }) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" className={`w-4 h-4 flex-shrink-0 mt-[3px] ${featured ? "text-[#c9a84c]" : "text-[#a07828]"}`} fill="currentColor">
      <path fillRule="evenodd" clipRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.7-9.3a1 1 0 00-1.4-1.4L9 10.6 7.7 9.3a1 1 0 00-1.4 1.4l2 2a1 1 0 001.4 0l4-4z" />
    </svg>
  );
}

function PricingCard({ card, ctaLabel, ctaHref }) {
  const f = card.featured;
  return (
    <div className={`relative overflow-hidden flex flex-col h-full min-w-0 rounded-2xl border p-6 sm:p-7 transition-all duration-300 hover:-translate-y-1.5 ${
      f
        ? "bg-[#0e0905] border-[#c9a84c]/50 shadow-[0_16px_40px_rgba(14,9,5,0.25)] hover:shadow-[0_20px_48px_rgba(201,168,76,0.22)] lg:-translate-y-3 lg:hover:-translate-y-4"
        : "bg-white border-[#c9a84c]/20 hover:shadow-[0_12px_32px_rgba(90,60,10,0.1)]"
    }`}>
      <span className={`absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent ${f ? "via-[#c9a84c]/70" : "via-[#c9a84c]/40"} to-transparent`} />

      {/* technique + description */}
      <p style={cinzel} className={`text-[10px] tracking-[0.2em] uppercase font-bold mb-2 ${f ? "text-[#c9a84c]" : "text-[#a07828]"}`}>{card.label}</p>
      <h3 style={cinzel} className={`text-[1.05rem] sm:text-[1.15rem] font-bold uppercase tracking-[0.04em] mb-3 ${f ? "text-white" : "text-[#1a0f02]"}`}>
        {card.href
          ? <a href={card.href} className={`transition-colors ${f ? "hover:text-[#ffe9a0]" : "hover:text-[#a07828]"}`}>{card.title}</a>
          : card.title}
      </h3>
      <p className={`text-[13px] leading-[1.75] mb-6 min-h-[4.5rem] ${f ? "text-white/60" : "text-[#6b5535]"}`}>{card.desc}</p>

      {/* price */}
      <div className={`border-t pt-5 pb-5 ${f ? "border-[#c9a84c]/25" : "border-[#c9a84c]/20"}`}>
        {card.perGraft ? (
          <div className="flex items-end justify-between gap-3">
            <p className={`text-[11px] font-semibold leading-snug ${f ? "text-[#c9a84c]" : "text-[#6b5535]"}`}>Per graft onwards</p>
            <div style={cinzel} className={`font-black text-[2.4rem] sm:text-[2.8rem] leading-none ${f ? "bg-gradient-to-br from-[#c9943a] via-[#ffe9a0] to-[#c9943a] bg-clip-text text-transparent" : "text-[#1a0f02]"}`}>
              {card.perGraft}
            </div>
          </div>
        ) : (
          <div style={cinzel} className={`font-black text-[1.35rem] sm:text-[1.5rem] leading-tight ${f ? "text-[#ffe9a0]" : "text-[#1a0f02]"}`}>
            {card.range}
          </div>
        )}
        {card.perGraft && (
          <div className="mt-3">
            <p className={`text-[11px] ${f ? "text-white/45" : "text-[#6b5535]"}`}>Total depends on grafts required</p>
            
          </div>
        )}
        
      </div>

      {/* features */}
      <ul className="flex-1 mb-6">
        {card.features.map((feat, i) => (
          <li key={i} className={`flex items-start gap-2.5 py-3 text-[12.5px] leading-snug border-t ${f ? "border-[#c9a84c]/15 text-white/75" : "border-[#c9a84c]/15 text-[#3a2e1e]"}`}>
            <CheckIcon featured={f} />
            <span>{feat}</span>
          </li>
        ))}
      </ul>

      {/* CTA */}
      <a href={ctaHref}
        style={f
          ? { ...cinzel, backgroundImage: "linear-gradient(135deg,#c9943a,#ffe9a0,#c9943a)", backgroundSize: "200% 100%" }
          : cinzel}
        className={`mt-auto block text-center text-[11px] font-bold tracking-[0.16em] uppercase px-6 py-3.5 rounded-md hover:-translate-y-0.5 transition-all ${
          f
            ? "text-[#1a0f02] hover:shadow-[0_8px_24px_rgba(201,168,76,0.35)]"
            : "bg-[#0e0905] text-[#c9a84c] hover:shadow-[0_8px_24px_rgba(14,9,5,0.25)]"
        }`}>
        {ctaLabel}
      </a>
    </div>
  );
}

/* ============================================================
   PAGE COMPONENT
============================================================ */
export default function HairTransplantCost() {
  const pageRef     = useRef(null);
  const heroEyeRef  = useRef(null);
  const heroHeadRef = useRef(null);
  const heroSubRef  = useRef(null);
  const sectionRefs = useRef([]);
  const addRef      = (el) => el && !sectionRefs.current.includes(el) && sectionRefs.current.push(el);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const ease = "power3.out";
      gsap.fromTo(heroEyeRef.current,  { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.7, ease });
      gsap.fromTo(heroHeadRef.current, { opacity: 0, y: 26 }, { opacity: 1, y: 0, duration: 0.75, ease, delay: 0.1 });
      gsap.fromTo(heroSubRef.current,  { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 0.7, ease, delay: 0.18 });
      sectionRefs.current.forEach((el) => {
        if (!el) return;
        gsap.fromTo(el, { opacity: 0, y: 36 }, {
          opacity: 1, y: 0, duration: 0.75, ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 88%", toggleActions: "play none none reverse" },
        });
      });
    }, pageRef);
    return () => ctx.revert();
  }, []);

  const wrap = "max-w-6xl mx-auto px-5 sm:px-8 lg:px-12";
  const sec  = "py-8 sm:py-8 md:py:10";

  return (
    <>
    <SEO
  title={`Hair Transplant Cost in ${HT.placeName} | Clinique Internationale`}
  description={`Explore hair transplant cost in ${HT.placeName} at Clinique Internationale, led by Dr. Bhavesh Gupta. Transparent pricing for Sapphire FUE, DHI, and advanced hair restoration.`}
  url={`${SITE_ORIGIN}${HT.costPath}`}
/>
      <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Raleway:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&display=swap" rel="stylesheet" />

      <div ref={pageRef} className="relative w-full bg-[#f2ece0] overflow-hidden mt-16 lg:mt-20" style={{ fontFamily: "'Raleway', sans-serif" }}>

  {/* ══════════════════════════════════════
      HERO
  ══════════════════════════════════════ */}
  <div className="relative bg-[#0e0905] overflow-hidden">
    <div className="absolute inset-0 opacity-40 pointer-events-none"
      style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E\")" }}
    />
    <div className={`${wrap} relative z-10 py-12 sm:py-8 lg:py-20 grid grid-cols-1 lg:grid-cols-[1.35fr_1fr] gap-10 lg:gap-14 items-center`}>
      {/* left */}
      <div className="min-w-0">
        <p ref={heroEyeRef} style={cinzel} className="text-[10.5px] tracking-[0.28em] uppercase mb-4 flex items-center gap-2.5 text-[#c9a84c]/70">
          <span className="w-6 h-px bg-[#c9a84c]/50" />
          {PAGE.hero.eyebrow}
        </p>
        <h1 ref={heroHeadRef} style={cinzel} className="font-black uppercase tracking-[0.04em] leading-[1.2] text-white text-[1.7rem] sm:text-[2.2rem] lg:text-[2.7rem] mb-5">
          {PAGE.hero.headingPlain}{" "}
          <span className="bg-gradient-to-br from-[#c9943a] via-[#ffe9a0] to-[#c9943a] bg-clip-text text-transparent">{PAGE.hero.headingAccent}</span>
          <span className="block">{PAGE.hero.tagline}</span>
        </h1>
        <p ref={heroSubRef} className="text-[14px] sm:text-[14.5px] leading-[1.85] text-white/65 max-w-xl mb-8">{PAGE.hero.sub}</p>
        <div className="flex items-center gap-4 flex-wrap">
          <a href={PAGE.cta.primary.href}
            style={{ ...cinzel, backgroundImage: "linear-gradient(135deg,#c9943a,#ffe9a0,#c9943a)", backgroundSize: "200% 100%" }}
            className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-3.5 rounded-full text-[#1a0f02] hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(201,168,76,0.35)] transition-all inline-block">
            {PAGE.cta.primary.label}
          </a>
          <a href={PAGE.cta.secondary.href}
            style={cinzel}
            className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-[13px] rounded-full bg-transparent border border-white/35 text-white hover:-translate-y-0.5 hover:border-[#c9a84c] hover:text-[#c9a84c] transition-all inline-block">
            {PAGE.cta.secondary.label}
          </a>
        </div>
      </div>

      {/* right: at a glance */}
      <div className="w-full max-w-md mx-auto lg:max-w-none min-w-0 rounded-2xl overflow-hidden border border-[#c9a84c]/40 bg-[#faf8f4] shadow-[0_16px_40px_rgba(0,0,0,0.35)]">
        <div style={cinzel} className="bg-[#1a0f02] text-[#c9a84c] text-center text-[11px] sm:text-[12px] font-bold tracking-[0.14em] uppercase px-5 py-3.5 border-b border-[#c9a84c]/30">
          {PAGE.hero.glance.title}
        </div>
        <div className="px-5 sm:px-6 py-2">
          {PAGE.hero.glance.rows.map((r, i) => (
            <div key={r.label} className={`flex items-center justify-between gap-4 py-4 ${i > 0 ? "border-t border-[#c9a84c]/20" : ""}`}>
              <span className="text-[12.5px] text-[#6b5535]">{r.label}</span>
              <span className="text-[12.5px] font-bold text-[#1a0f02] text-right">{r.val}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>

        {/* BREADCRUMB */}
        <div className="bg-[#0e0905]/95 border-b border-[#c9a84c]/10">
          <div className={`${wrap} py-3 flex flex-wrap items-center gap-2`}>
            {PAGE.breadcrumb.map((b, i) => (
              <span key={i} className="flex items-center gap-2">
                {i > 0 && <span className="text-[#c9a84c]/30 text-xs">›</span>}
                {b.href
                  ? <a href={b.href} style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]/60 hover:text-[#c9a84c] transition-colors">{b.label}</a>
                  : <span style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]">{b.label}</span>}
              </span>
            ))}
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 1 WHAT IS HAIR TRANSPLANT
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef} className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-start">
            {/* text */}
            <div>
              <Eyebrow>{PAGE.whatIs.eyebrow}</Eyebrow>
              <SectionHeading left>{PAGE.whatIs.heading}</SectionHeading>
              {PAGE.whatIs.paragraphs.map((p, i) => (
                <p key={i} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] mb-4">{p}</p>
              ))}
            </div>
            {/* stats */}
            <div className="relative overflow-hidden bg-[#0e0905] border border-[#c9a84c]/20 rounded-2xl p-7 md:mt-14">
              <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/50 to-transparent" />
              <p style={cinzel} className="text-[10px] tracking-[0.22em] uppercase text-[#c9a84c]/60 mb-5">Quick Numbers</p>
              <div className="grid grid-cols-2 gap-6">
                {PAGE.whatIs.stats.map((s) => (
                  <div key={s.val}>
                    <div style={cinzel} className="font-black text-[1.55rem] leading-none mb-1 bg-gradient-to-br from-[#c9943a] via-[#ffe9a0] to-[#c9943a] bg-clip-text text-transparent">{s.val}</div>
                    <div className="text-[11.5px] text-white/45 leading-snug">{s.sub}</div>
                  </div>
                ))}
              </div>
              <span className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/20 to-transparent" />
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 2 PRICING CARDS
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-8 sm:py-8 md:py:10">
          <div className={wrap}>
            <div ref={addRef}>
              <Eyebrow>{PAGE.pricing.eyebrow}</Eyebrow>
              <SectionHeading>{PAGE.pricing.heading}</SectionHeading>
              {PAGE.pricing.intro.map((p, i) => (
                <p key={i} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-4">{p}</p>
              ))}
              <div className="mt-12 lg:mt-14 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-7 max-w-md mx-auto lg:max-w-none items-stretch">
                {PAGE.pricing.cards.map((card) => (
                  <PricingCard
                    key={card.title}
                    card={card}
                    ctaLabel={PAGE.pricing.cta}
                    ctaHref={PAGE.cta.primary.href}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            SECTION 3 FACTORS
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef}>
            <Eyebrow>{PAGE.factors.eyebrow}</Eyebrow>
            <SectionHeading>{PAGE.factors.heading}</SectionHeading>
            <p className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-10">{PAGE.factors.intro}</p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {PAGE.factors.list.map((f) => (
                <div key={f.num} className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 relative overflow-hidden hover:-translate-y-1 hover:shadow-[0_12px_32px_rgba(90,60,10,0.1)] transition-all duration-300">
                  <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                  <div className="flex gap-4 items-start">
                    <span style={cinzel} className="font-black text-[2rem] leading-none text-[#c9a84c]/20 select-none flex-shrink-0">{f.num}</span>
                    <div>
                      <div style={cinzel} className="text-[13px] font-bold tracking-[0.05em] uppercase text-[#1a0f02] mb-2">{f.title}</div>
                      <p className="text-[13.5px] leading-[1.8] text-[#6b5535]">{f.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 4 METHODS & COST TABLES
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0e0905] py-8 sm:py-8 md:py:10">
          <div className={wrap}>
            <div ref={addRef}>
              <Eyebrow light>{PAGE.methodsCost.eyebrow}</Eyebrow>
              <SectionHeading light>{PAGE.methodsCost.heading}</SectionHeading>
              <p className="text-[14.5px] leading-[1.85] text-white/60 max-w-3xl mx-auto text-center mb-12">{PAGE.methodsCost.intro}</p>

              {/* Sapphire FUE */}
              <div className="mb-12">
                <div className="flex items-center gap-3 mb-4">
                  <span className="w-1 h-8 rounded-full bg-[#c9a84c]" />
                  {PAGE.methodsCost.sapphire.href
                    ? <a href={PAGE.methodsCost.sapphire.href} style={cinzel} className="text-[1rem] sm:text-[1.15rem] font-bold uppercase tracking-[0.06em] text-[#c9a84c] hover:text-[#ffe9a0] transition-colors">{PAGE.methodsCost.sapphire.title}</a>
                    : <span style={cinzel} className="text-[1rem] sm:text-[1.15rem] font-bold uppercase tracking-[0.06em] text-[#c9a84c]">{PAGE.methodsCost.sapphire.title}</span>}
                </div>
                <p className="text-[14px] leading-[1.85] text-white/60 mb-6">{PAGE.methodsCost.sapphire.desc}</p>
                <StyledTable heads={PAGE.methodsCost.sapphire.heads}>
                  {PAGE.methodsCost.sapphire.rows.map((r, i) => (
                    <tr key={i} className={`border-t border-[#c9a84c]/10 ${i % 2 === 0 ? "bg-white/[0.03]" : "bg-white/[0.06]"} hover:bg-[#c9a84c]/[0.08] transition-colors`}>
                      <td className="px-5 py-4 text-[13px] font-semibold text-white/85 whitespace-nowrap">{r.grafts}</td>
                      <td className="px-5 py-4 text-[13px] text-white/60 whitespace-nowrap">{r.rate}</td>
                      <td className="px-5 py-4 text-[13px] font-bold text-[#c9a84c] whitespace-nowrap">{r.cost}</td>
                    </tr>
                  ))}
                </StyledTable>
              </div>

              {/* DHI */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <span className="w-1 h-8 rounded-full bg-[#c9a84c]" />
                  {PAGE.methodsCost.dhi.href
                    ? <a href={PAGE.methodsCost.dhi.href} style={cinzel} className="text-[1rem] sm:text-[1.15rem] font-bold uppercase tracking-[0.06em] text-[#c9a84c] hover:text-[#ffe9a0] transition-colors">{PAGE.methodsCost.dhi.title}</a>
                    : <span style={cinzel} className="text-[1rem] sm:text-[1.15rem] font-bold uppercase tracking-[0.06em] text-[#c9a84c]">{PAGE.methodsCost.dhi.title}</span>}
                </div>
                <p className="text-[14px] leading-[1.85] text-white/60 mb-6">{PAGE.methodsCost.dhi.desc}</p>
                <StyledTable heads={PAGE.methodsCost.dhi.heads}>
                  {PAGE.methodsCost.dhi.rows.map((r, i) => (
                    <tr key={i} className={`border-t border-[#c9a84c]/10 ${i % 2 === 0 ? "bg-white/[0.03]" : "bg-white/[0.06]"} hover:bg-[#c9a84c]/[0.08] transition-colors`}>
                      <td className="px-5 py-4 text-[13px] font-semibold text-white/85 whitespace-nowrap">{r.grafts}</td>
                      <td className="px-5 py-4 text-[13px] text-white/60 whitespace-nowrap">{r.rate}</td>
                      <td className="px-5 py-4 text-[13px] font-bold text-[#c9a84c] whitespace-nowrap">{r.cost}</td>
                    </tr>
                  ))}
                </StyledTable>
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            SECTION 5 WHY CLINIQUE IS COST EFFECTIVE
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef}>
            <Eyebrow>{PAGE.whyClinique.eyebrow}</Eyebrow>
            <SectionHeading>{PAGE.whyClinique.heading}</SectionHeading>
            <p className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-10">{PAGE.whyClinique.intro}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
              {PAGE.whyClinique.points.map((p) => (
                <div key={p.num} className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 relative overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(90,60,10,0.1)] transition-all duration-300">
                  <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#c9a84c]/15 to-[#c9a84c]/[0.03] border border-[#c9a84c]/20 flex items-center justify-center mb-4">
                    <span style={cinzel} className="text-[11px] font-black text-[#c9a84c]">{p.num}</span>
                  </div>
                  <div style={cinzel} className="text-[12.5px] font-bold tracking-[0.06em] uppercase text-[#1a0f02] mb-2.5">{p.title}</div>
                  <p className="text-[13px] leading-[1.75] text-[#6b5535]">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            MISSION STRIP
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0e0905] py-14 sm:py-8">
          <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
            <p style={cinzel} className="text-[1rem] sm:text-[1.2rem] md:text-[1.35rem] font-light leading-[1.7] text-white/85 tracking-[0.02em]">
              "We believe that every patient deserves{" "}
              <em className="italic" style={{ color: "#c9a84c" }}>world-class hair restoration</em>{" "}
              at a price that is honest, transparent and accessible because great results shouldn't come at the cost of trust."
            </p>
            <p className="text-[11px] tracking-[0.18em] uppercase text-[#c9a84c]/50 mt-5">
             Dr. Bhavesh Gupta, Founder · Clinique Internationale
            </p>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            CTA
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef} className="max-w-xl mx-auto text-center">
            <Eyebrow>{PAGE.cta.eyebrow}</Eyebrow>
            <h3 style={cinzel} className="font-black text-[1.3rem] sm:text-[1.65rem] md:text-[1.9rem] text-[#1a0f02] uppercase tracking-[0.06em] mb-3.5">
              {PAGE.cta.heading}
            </h3>
            <p className="text-[14px] text-[#6b5535] leading-[1.75] mb-8">{PAGE.cta.sub}</p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <a href={PAGE.cta.primary.href}
                style={{ ...cinzel, backgroundImage: "linear-gradient(135deg,#c9943a,#ffe9a0,#c9943a)", backgroundSize: "200% 100%" }}
                className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-3.5 rounded-md text-[#1a0f02] hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(201,168,76,0.35)] transition-all inline-block">
                {PAGE.cta.primary.label}
              </a>
              <a href={PAGE.cta.secondary.href}
                style={cinzel}
                className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-[13px] rounded-md bg-transparent border border-[#1a0f02]/35 text-[#1a0f02] hover:-translate-y-0.5 hover:border-[#c9a84c] hover:text-[#a07828] transition-all inline-block">
                {PAGE.cta.secondary.label}
              </a>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}